import React, { useEffect, useState } from "react";
import '../css/activity.css'
import Modal from "rsuite/esm/Modal";
import { decompressjsondata, getFormattedDate } from "../../../../actions/common";
import Accordion from "./common/Accordion";
import { apiRequest, isEmpty } from "../../../../utils/utils";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import EmailActivity from "./activity/EmailActivity";
import NoteCreated from "./activity/NoteCreated";
import CreatedActivity from "./activity/CreatedActivity";
import { AgGridReact } from "ag-grid-react";
import pako from "pako";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import NoDataFound from "./common/NoDataFound";
import Loader from "rsuite/esm/Loader";

const ActivityPanel = ({ customerDetails, usersList, productsList }) => {
  const serverId = 1;
  const studioId = parseInt(customerDetails.customer_id);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [activities, setActivities] = useState([]);
  const [pagehits, setPageHits] = useState([]);
  const [loginDetails, setLoginDetails] = useState([]);
  const [uploadDetails, setUploadDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const isDebug = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.get("debug");
    const debug = queryString == null || queryString == "false" ? false : true;
    return debug;
  };


  const avatarUrl = (name) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      name
    )}&color=ff0000&size=40&background=random`;

  const { customer_identifier } = useParams();


  const fetchAllContactData = async () => {
  try {
    const mauticId = Number(customerDetails.mautic_id);

    const [
      activityRes,
      pageHitsRes,
    ] = await Promise.all([
      apiRequest(
        `${process.env.REACT_APP_CRM}/activity/logs`,
        'POST',
        { mautic_id: mauticId }
      ),
      apiRequest(
        `${process.env.REACT_APP_CRM_ADMIN}/api/crm/contact/page-hits`,
        'POST',
        { mautic_id: mauticId }, {}, true
      ),
    ]);

    setActivities(activityRes.data || []);
    setPageHits(pageHitsRes.data || []);

  } catch (error) {
    console.error("Error fetching contact data:", error);
  }
};

  const formatKey = (key) =>
    typeof key === "string"
      ? key
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/^\w|\s\w/g, (c) => c.toUpperCase())
      : key;

  const formatActivityVal = (key, val = '-') => {
    if (
      ['sales_manager', 'tse_owner', 'account_manager'].indexOf(key) !== -1 &&
      val !== undefined &&
      val !== null &&
      val !== '' &&
      usersList &&
      usersList[val]
    ) {
      return usersList[val].name || "N/A";
    }
    else if (['associated_products', 'product_key', 'product'].includes(key) && val) {
      let product;
      if (typeof val === 'string') {
        product = productsList.find(product => product.product_key === val);
        product = product && product.value ? product.value : "-";
      } else if (Array.isArray(val)) {
        product = val
          .map(y => {
            const foundProduct = productsList.find(product => product.product_key === y);
            return foundProduct ? foundProduct.value : y;
          })
          .join(', ');
      }
      return product ? product : val;
    }
    else if (['logo'].includes(key) && val) {
      return <img src={val} alt="Logo" style={{ borderRadius: "10px" }} />;
    }
    else if (['domain'].includes(key) && val) {
      return <a className="email" href={val} target="_blank">{val}</a>;
    }
    else if (['email'].includes(key) && val) {
      return <a className="email" href={`mailto:${val}`} target="_blank">{val}</a>;
    }
    else if (['crm_status'].includes(key) && val) {
      return Boolean(val) ? "Active" : "Inactive";
    }
    else if (['created_date','last_meeting_booked', 'free_trial_expiry_date', 'next_infra_billing_date', 'kafka_billing_last_updated_timestamp', 'first_subscription_date', 'last_transaction_date', 'kafka_user_last_updated_timestamp', 'cron_last_updated_timestamp', 'created_at', 'invoice_raise_date', "updated_at", 'milestone_receive', 'milestone_markaspaid_date'].includes(key)) {
      return val ? getFormattedDate(val, "MMM dd, yyyy") : "-";
    }
    else if (
      typeof val === "boolean" ||
      val === 0 ||
      val === 1 ||
      val === "0" ||
      val === "1" ||
      ['has_products', 'sql'].includes(key)
    ) {
      return val === true ||
        val === 1 ||
        val === "1" ||
        val === "true"
        ? "Yes"
        : "No";
    }
    else if (Array.isArray(val)) {
      return val.join(", ");
    }
    else {
      return typeof val === "string" ? formatKey(val) : val;
    }
  }

  function getActivityText(modalData) {
    if (!modalData) {
      return "";
    }

    var eventType = modalData.event_type
      ? formatKey(modalData.event_type)
      : "";

    var eventAction = modalData.event_action
      ? formatKey(modalData.event_action)
      : "";

    var userName = "Unknown";

    if (
      modalData.muvi_useruuid &&
      usersList &&
      usersList[modalData.muvi_useruuid] &&
      usersList[modalData.muvi_useruuid].name
    ) {
      userName = usersList[modalData.muvi_useruuid].name;
    } else if (customerDetails && customerDetails.name) {
      userName = formatKey(customerDetails.name);
    }

    return eventType + " " + eventAction + " by " + userName;
  }

  const showLoginDetails = () => {

    setLoading(true);
    const debug = isDebug();
    let bodyParams = {
      studio_id: studioId,
      is_live: false,
      // enterprise_api_gateway_url: url,
      server_id: serverId,
      debug,
    };

    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi5/show-login-details", {
      method: "POST",
      dataType: "json",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        setLoginDetails((findresponse && findresponse.login_details) || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const showUploadDetails = () => {
    setLoading(true);
    const debug = isDebug();
    let bodyParams = {
      studio_id: studioId,
      is_live: false,
      // enterprise_api_gateway_url: url,
      server_id: serverId,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi5/show-upload-details", {
      method: "POST",
      dataType: "json",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        setUploadDetails((findresponse && findresponse.upload_details) || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };


  useEffect(() => {
    const fetchAll = async () => {
      try {

        if (customerDetails.mautic_id) {
          fetchAllContactData();
        }
        if (studioId) {
          showLoginDetails();
          showUploadDetails();
        } else {
          setLoginDetails([])
          setUploadDetails([])
        }
      } catch (err) {
        console.error("Billing fetch error:", err);
      }
    };

    fetchAll();
  }, [customerDetails]);



  return (
    <div className="flex-col gap-8">
      <div style={{ backgroundColor: "white" }}>
        {loading && (
          <div className="accordion-component p-8 flex justify-center">
            <Loader content="Loading Content..." />
          </div>
        )}
        {
          !loading &&
          isEmpty(activities) &&
          isEmpty(loginDetails) &&
          isEmpty(pagehits) &&
          isEmpty(uploadDetails) && (
            <NoDataFound />
          )
        }
      </div>
      {
        !loading && activities && activities.length > 0 &&

        <Accordion header="Activity" targetID="payment-history">
          <div className="activity-wrapper">
            <div className="timeline">
              {activities.map((item) => (
                <div className="int-timeline-item" key={item._id}>
                  <div className="avatar">
                    <img
                      src={usersList[item.muvi_useruuid] && item.muvi_useruuid &&
                        usersList[item.muvi_useruuid].profile_pic || (customerDetails && customerDetails.name && avatarUrl(formatKey(customerDetails.name)))}
                      alt={usersList[item.muvi_useruuid] &&
                        usersList[item.muvi_useruuid].name}
                    />
                  </div>

                  <div className="tcontent">
                    <div className="left">
                      <div className="user"> {usersList[item.muvi_useruuid] && item.muvi_useruuid &&
                        usersList[item.muvi_useruuid].name + " (Muvi)" || (customerDetails && formatKey(customerDetails.name))}</div>
                      <div className="event">
                        {formatKey(item.event_type)}{" "}
                        {"=>"} {" "}
                        {item.event_action && (
                          <span>
                            {formatKey(item.event_action)}{" "}

                          </span>
                        )}
                        {item.event_action && item.new_data && item.new_data.product_key && (
                          <span style={{ color: "black" }}>
                            {(["free trial", "subscription", "free signup", "free trial"].includes(item.event_type) &&
                              ["created", "updated", "started"].includes(item.event_action))
                              ? `(${formatActivityVal("product_key", item.new_data.product_key)})`
                              : ""}
                          </span>
                        )}


                      </div>
                      <div className="time">
                        {getFormattedDate(
                          item.created_at,
                          "MMM dd, yyyy h:mm a"
                        )}{" "}
                        IST
                      </div>
                    </div>

                    {(Object.keys(item.old_data).length > 0 ||
                      Object.keys(item.new_data).length > 0) && (
                        <button
                          className="revision-btn"
                          onClick={() => {
                            setModalData(item);
                            setShowModal(true);
                          }}
                        >
                          Revision
                        </button>
                      )}
                  </div>
                </div>
              ))}
            </div>

            <Modal open={showModal} centered onClose={() => setShowModal(false)} size="sm">
              {/* Header */}
              <Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h5 style={{ margin: 0 }}>History Revision</h5>
                    <small style={{ color: "#6b7280" }}>
                      {getActivityText(modalData)}
                    </small>
                  </div>
                </div>
              </Modal.Header>

              {/* Body */}
              <Modal.Body>
                {modalData ? (
                  modalData.event_type === "email" ? (
                    /* EMAIL VIEW */
                    <EmailActivity data={modalData} />
                  ) : (["user", "free trial", "subscription", "free signup"].includes(modalData.event_type) && ["created", "started"].includes(modalData.event_action)) ? (
                    /* Note Created */
                    <CreatedActivity modalData={modalData} formatKey={formatKey} formatActivityVal={formatActivityVal} />
                  ) : (["note"].includes(modalData.event_type) && ["created"].includes(modalData.event_action)) ? (
                    <NoteCreated modalData={modalData} formatKey={formatKey} formatActivityVal={formatActivityVal} />
                  ) : (
                    /* DEFAULT HISTORY TABLE */
                    <table className="history-table">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>From</th>
                          <th
                            style={{
                              textAlign: "center",
                              fontFamily: "'Font Awesome 5 Pro', sans-serif",
                              fontWeight: 100,
                            }}
                          >
                            {"=>"}
                          </th>
                          <th>To</th>
                        </tr>
                      </thead>

                      <tbody>
                        {Object.keys({
                          ...(modalData.old_data || {}),
                          ...(modalData.new_data || {}),
                        }).map((key) => (
                          <tr key={key}>
                            <td>{key === "product_key" ? "Product" : formatKey(key)}</td>

                            <td className="oldd">
                              {formatActivityVal(key, modalData.old_data[key]) || "—"}
                            </td>

                            <td className="arrow"></td>

                            <td className="neww">
                              {formatActivityVal(key, modalData.new_data[key]) || "—"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                ) : null}
              </Modal.Body>

            </Modal>
          </div>
        </Accordion>
      }
      {
        !loading && pagehits && pagehits.length > 0 &&

        <Accordion header="Page Hits" targetID="page-hits">
          <div className="activity-wrapper">
            <div className="timeline">
              {pagehits.map((item) => (
                <div className="int-timeline-item" key={item._id}>
                  <div className="avatar">
                    <img
                      src={usersList[item.muvi_useruuid] &&
                        usersList[item.muvi_useruuid].profile_pic || (customerDetails && customerDetails.name && avatarUrl(formatKey(customerDetails.name)))}
                      alt={usersList[item.muvi_useruuid] &&
                        usersList[item.muvi_useruuid].name}
                    />
                  </div>

                  <div className="tcontent">
                    <div className="left">
                      <div className="user"> {usersList[item.muvi_useruuid] &&
                        usersList[item.muvi_useruuid].name + " (Muvi)" || (customerDetails && formatKey(customerDetails.name))}</div>
                      <div className="event">
                        {item.page_hit_id}{" "}
                        {"=>"} {" "}
                        {item.url && (
                          <span>
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                            {item.url_title || item.url}{" "}
                            </a>
                          </span>
                        )}


                      </div>
                      <div className="time">
                        {getFormattedDate(
                          item.date,
                          "MMM dd, yyyy h:mm a"
                        )}{" "}
                        IST
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </div>

            <Modal open={showModal} centered onClose={() => setShowModal(false)} size="sm">
              {/* Header */}
              <Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h5 style={{ margin: 0 }}>History Revision</h5>
                    <small style={{ color: "#6b7280" }}>
                      {getActivityText(modalData)}
                    </small>
                  </div>
                </div>
              </Modal.Header>

              {/* Body */}
              <Modal.Body>
                {modalData ? (
                  modalData.event_type === "email" ? (
                    /* EMAIL VIEW */
                    <EmailActivity data={modalData} />
                  ) : (["user", "free trial", "subscription", "free signup"].includes(modalData.event_type) && ["created", "started"].includes(modalData.event_action)) ? (
                    /* Note Created */
                    <CreatedActivity modalData={modalData} formatKey={formatKey} formatActivityVal={formatActivityVal} />
                  ) : (["note"].includes(modalData.event_type) && ["created"].includes(modalData.event_action)) ? (
                    <NoteCreated modalData={modalData} formatKey={formatKey} formatActivityVal={formatActivityVal} />
                  ) : (
                    /* DEFAULT HISTORY TABLE */
                    <table className="history-table">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>From</th>
                          <th
                            style={{
                              textAlign: "center",
                              fontFamily: "'Font Awesome 5 Pro', sans-serif",
                              fontWeight: 100,
                            }}
                          >
                            {"=>"}
                          </th>
                          <th>To</th>
                        </tr>
                      </thead>

                      <tbody>
                        {Object.keys({
                          ...(modalData.old_data || {}),
                          ...(modalData.new_data || {}),
                        }).map((key) => (
                          <tr key={key}>
                            <td>{key === "product_key" ? "Product" : formatKey(key)}</td>

                            <td className="oldd">
                              {formatActivityVal(key, modalData.old_data[key]) || "—"}
                            </td>

                            <td className="arrow"></td>

                            <td className="neww">
                              {formatActivityVal(key, modalData.new_data[key]) || "—"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                ) : null}
              </Modal.Body>

            </Modal>
          </div>
        </Accordion>
      }
      {
        !loading && loginDetails && loginDetails.length > 0 &&

        <Accordion header="Login" targetID="logindetailspanel">
          <div
            className="ag-theme-alpine"
            style={{
              height: "200px",
              width: "100%",
              padding: "0 6px",
              "--ag-row-group-indent-size": "20px",
              overflowY: "auto",
            }}
            tabIndex={0}
          >
            <AgGridReact
              columnDefs={[
                {
                  headerName: "Email",
                  field: "email",
                  flex: 1,
                  cellRenderer: (params) => {
                    if (params.value) {
                      return params.value;
                    } else {
                      return "NA";
                    }
                  },
                },
                {
                  headerName: "Date & Time",
                  field: "login_at",
                  flex: 1,
                  cellRenderer: (params) => {
                    if (params.value) {
                      return params.value;
                    } else {
                      return "NA";
                    }
                  },
                },
              ]}
              rowData={loginDetails || []}
              defaultColDef={{
                resizable: true,
                sortable: true,
              }}
              rowHeight={40}
              suppressHorizontalScroll={false}
              domLayout="autoHeight"
              theme="legacy"
              suppressContextMenu={true}
              enableCellTextSelection={true}
              enableClipboard={true}
              copyHeadersToClipboard={true}
              enableRangeSelection={true}
            />
          </div>
        </Accordion>
      }
      {
        !loading && uploadDetails && uploadDetails.length > 0 &&

        <Accordion header="Upload Details" targetID="uploaddetailspanel">
          <div
            className="ag-theme-alpine"
            style={{
              height: "200px",
              width: "100%",
              padding: "0 6px",
              "--ag-row-group-indent-size": "20px",
              overflowY: "auto",
            }}
            tabIndex={0}
          >
            <AgGridReact
              columnDefs={[
                {
                  headerName: "File Name",
                  field: "film_name",
                  flex: 1,
                  cellRenderer: (params) => {
                    if (params.value) {
                      return params.value;
                    } else {
                      return "NA";
                    }
                  },
                },
                {
                  headerName: "Upload Start Time",
                  field: "upload_start_time",
                  flex: 1,
                  cellRenderer: (params) => {
                    if (params.value) {
                      return params.value;
                    } else {
                      return "NA";
                    }
                  },
                },
                {
                  headerName: "Upload End Time",
                  field: "upload_end_time",
                  flex: 1,
                  cellRenderer: (params) => {
                    if (params.value) {
                      return params.value;
                    } else {
                      return "NA";
                    }
                  },
                },
              ]}
              rowData={uploadDetails || []}
              defaultColDef={{
                resizable: true,
                sortable: true,
              }}
              rowHeight={40}
              suppressHorizontalScroll={false}
              domLayout="autoHeight"
              theme="legacy"
              suppressContextMenu={true}
              enableCellTextSelection={true}
              enableClipboard={true}
              copyHeadersToClipboard={true}
              enableRangeSelection={true}
            />
          </div>
        </Accordion>
      }
    </div>
  );
};

export default ActivityPanel;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ActivityPanel.js